import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function AnimatedBackground({ className }: { className?: string }) {
  return (
    <div className={cn("fixed inset-0 -z-10 overflow-hidden", className)}>
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-blue-50/20 to-purple-50/20 dark:from-gray-950 dark:via-blue-950/10 dark:to-purple-950/10" />

      <motion.div
        className="absolute inset-0 opacity-30 dark:opacity-20"
        style={{
          background: `
            radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.3) 0%, transparent 50%)
          `,
        }}
        animate={{
          background: [
            `
              radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.3) 0%, transparent 50%)
            `,
            `
              radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 20% 20%, rgba(139, 92, 246, 0.3) 0%, transparent 50%)
            `,
          ],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <motion.div
        className="absolute inset-0 opacity-20 dark:opacity-10"
        style={{
          background: `
            radial-gradient(circle at 40% 60%, rgba(16, 185, 129, 0.2) 0%, transparent 50%),
            radial-gradient(circle at 60% 40%, rgba(245, 158, 11, 0.2) 0%, transparent 50%)
          `,
        }}
        animate={{
          background: [
            `
              radial-gradient(circle at 40% 60%, rgba(16, 185, 129, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 60% 40%, rgba(245, 158, 11, 0.2) 0%, transparent 50%)
            `,
            `
              radial-gradient(circle at 60% 60%, rgba(16, 185, 129, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(245, 158, 11, 0.2) 0%, transparent 50%)
            `,
          ],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2,
        }}
      />

      <svg className="absolute inset-0 w-full h-full opacity-10 dark:opacity-5">
        <defs>
          <linearGradient
            id="flow-gradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="50%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#10b981" />
          </linearGradient>
        </defs>

        <motion.path
          d="M-100,200 Q250,150 600,250 T1400,200"
          stroke="url(#flow-gradient)"
          strokeWidth="2"
          fill="none"
          animate={{
            d: [
              "M-100,200 Q250,150 600,250 T1400,200",
              "M-100,250 Q250,200 600,300 T1400,250",
              "M-100,200 Q250,150 600,250 T1400,200",
            ],
          }}
          transition={{
            duration: 12,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        <motion.path
          d="M-100,800 Q400,750 800,850 T1500,800"
          stroke="url(#flow-gradient)"
          strokeWidth="2"
          fill="none"
          animate={{
            d: [
              "M-100,800 Q400,750 800,850 T1500,800",
              "M-100,850 Q400,800 800,900 T1500,850",
              "M-100,800 Q400,750 800,850 T1500,800",
            ],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1,
          }}
        />

        <motion.path
          d="M1600,400 Q1100,350 700,450 T0,400"
          stroke="url(#flow-gradient)"
          strokeWidth="2"
          fill="none"
          animate={{
            d: [
              "M1600,400 Q1100,350 700,450 T0,400",
              "M1600,450 Q1100,400 700,500 T0,450",
              "M1600,400 Q1100,350 700,450 T0,400",
            ],
          }}
          transition={{
            duration: 14,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.5,
          }}
        />

        <motion.path
          d="M1600,600 Q1250,550 900,650 T100,600"
          stroke="url(#flow-gradient)"
          strokeWidth="2"
          fill="none"
          animate={{
            d: [
              "M1600,600 Q1250,550 900,650 T100,600",
              "M1600,650 Q1250,600 900,700 T100,650",
              "M1600,600 Q1250,550 900,650 T100,600",
            ],
          }}
          transition={{
            duration: 16,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1.5,
          }}
        />
      </svg>

      <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_49%,rgba(59,130,246,0.05)_50%,transparent_51%)] bg-[size:20px_20px]" />
    </div>
  );
}
